import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import axios from '../utils/posAxios';
import { MdDone, MdClear } from 'react-icons/md';
import StorageService from '../services/StorageService';
import update from 'immutability-helper';

class CrmAddressForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      customer_id: this.props.match.params.id,
      data_id: '',
      data: [],
      dataTemplate: [],
      billing_unit: '',
      billing_postal_code: '',
    };
  }

  componentDidMount() {
    this.getDataTemplate();
    if (this.props.data.isEdit) {
      let data = this.props.data;
      this.setState({
        isEdit: data.isEdit,
        data_id: data.selectedData.data_id,
      });
    } else {
      let address = this.props.customerData;
      this.setState({
        address: address.billing_address,
        billing_unit: address.billing_unit,
        billing_postal_code: address.billing_postal_code,
        country: address.billing_country,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = event => {
    const { name, value } = event.target;
    let index = this.state.data.findIndex(x => x.name === name);
    this.setState({
      data: update(this.state.data, {
        [index]: { value: { $set: value } },
      }),
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    if (this.state.isEdit) {
      this.editData(user, comp, url);
    } else {
      this.addData(user, comp, url);
    }
  };

  getDataTemplate = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer/template', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        let array = [];
        let address = this.props.customerData;
        for (let i of response.data.data) {
          let value = '';
          if (this.props.data.isEdit) {
            let customData = this.props.data.selectedData;
            Object.keys(customData).map(sitem => {
              if (i.name == sitem) {
                value = customData[sitem];
              }
            });
          } else {
            if (JSON.parse(i.data).prefill) {
              console.log(JSON.parse(i.data).prefill);
              console.log(address[JSON.parse(i.data).prefill]);
              value = address[JSON.parse(i.data).prefill];
            }
          }
          let data = {
            name: i.name,
            value: value,
          };
          array.push(data);
        }

        if (this._isMounted) {
          this.setState({
            dataTemplate: result.data,
            data: array,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  addData(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.customer_id,
      data: this.state.data,
      created_by: user.email,
    };
    axios
      .post(url + ':3004/v1/customer/data/create', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'New Data added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  editData(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.customer_id,
      data_id: this.state.data_id,
      data: this.state.data,
      update_by: user.email,
    };

    axios
      .post(url + ':3004/v1/customer/data/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Data updated successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    console.log(this.state.data);
    const detail = (
      <Row>
        <Col md={12}>
          {this.state.dataTemplate.map(item => {
            const value =
              this.state.data &&
              this.state.data.find(x => x.name === item.name).value;
            return (
              <FormGroup key={item.name}>
                <Label>{item.title}</Label>
                {item.data_type === 'select' ? (
                  <Input
                    type={item.data_type == 'string' ? 'text' : item.data_type}
                    name={item.name}
                    value={value}
                    onChange={this.changeHandler}
                    placeholder={
                      item.name === 'install_date' ? 'YYYY-MM-DD' : undefined
                    }
                    required
                  >
                    <option></option>
                    {JSON.parse(item.data).map((i, index) => {
                      return (
                        <option value={i.name} key={i.name + index}>
                          {i.name}
                        </option>
                      );
                    })}
                  </Input>
                ) : (
                  <Input
                    type={item.data_type == 'string' ? 'text' : item.data_type}
                    name={item.name}
                    // value={
                    //   this.state.isEdit === false &&
                    //   JSON.parse(item.data).prefill
                    //     ? this.state[JSON.parse(item.data).prefill]
                    //     : value
                    // }
                    value={value}
                    maxLength={JSON.parse(item.data).limit}
                    onChange={this.changeHandler}
                    placeholder={
                      item.name === 'install_date' ? 'YYYY-MM-DD' : undefined
                    }
                    required={
                      JSON.parse(item.data).required === '1' ? true : false
                    }
                  />
                )}
              </FormGroup>
            );
          })}
        </Col>
      </Row>
    );

    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Customer Detail
        </ModalHeader>
        <ModalBody>{detail}</ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default CrmAddressForm;
